import React from 'react'
import styles from './InputLogin.module.css'

const InputLogin = ({
    title, 
    type, 
    style, 
    maxLength,
    onChange,
}) => {
    return (
        <input
            className={styles.container}
            style={style}
            name="name"
            type={type}
            onChange={(e) => onChange(e.target.value)}
            maxLength={maxLength}
            placeholder={title}/>
    )
}

export default InputLogin
